import { render, staticRenderFns } from "./reportlive.vue?vue&type=template&id=f2327f30&scoped=true&"
import script from "./reportlive.vue?vue&type=script&lang=js&"
export * from "./reportlive.vue?vue&type=script&lang=js&"
import style0 from "./reportlive.vue?vue&type=style&index=0&id=f2327f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2327f30",
  null
  
)

export default component.exports